import { atom } from "recoil";

export const snackAlertState = atom({
  key: "snackAlertState",
  default: {
    open: false,
    message: "all is good",
    severity: "success", // success, error, warning, info
  },
});




export const popupState = atom({
  key: "popupState",
  default: {
    isOpen: false,
    title: "",
    content: null,
    clearHandel: null,
    sendReq: null,
  },
});


export const selectedStreamState = atom({
  key: "selectedStreamState",
  default: []
});



export const filterResultState = atom({
  key: "filterResultState",
  default: {
    startDate: null,
    startTime: null,
    endDate: null,
    endTime: null,
    limit: "25",
    id: null,
  },
});

export const isActiveUserState = atom({
  key: "isActiveUserState",
  default: true,
});




// Seeded from localStorage so the first render after a page load already knows the user
// is signed in; otherwise the router briefly sees no token.
const storedAuth = () => {
  try {
    if (!localStorage?.token) return null;
    return {
      isAuthenticated: true,
      expire: localStorage.expire,
      token: localStorage.token,
      role: localStorage.role,
    };
  } catch {
    return null;
  }
};

export const authState = atom({
  key: "authState",
  default: storedAuth(),
});

// The workspace the user is working in ({ workspace_id, name, member_role } or null).
// The backend keeps it per user; changing it remounts the current page.
export const activeWorkspaceState = atom({
  key: "activeWorkspaceState",
  default: null,
});

// Feature keys the user may use in the active workspace (user ∩ workspace).
// null until loaded, so pages don't flash "no access" on first render.
export const featuresState = atom({
  key: "featuresState",
  default: null,
});

export const streamState = atom({
  key: "streamState",
  default: {
    data: [],
    selected: [],
    loading: true,
    error: null,
  },
});

export const notificationHasUnread = atom({
  key: 'notificationHasUnread',
  default: true, // true = show red dot, false = hide it
});

export const themeState = atom({
  key: 'themeState',
  default: 'dark', // 'light', 'dark', 'highContrast'
});

export const logoPreferencesState = atom({
  key: 'logoPreferencesState',
  default: {
    useCustomLogos: true,
  },
});
